export const inboxLink = "https://inbox-ticket.web.app/tickets/new";
export { default as docMasks } from "./docMasks";
export { default as colors } from "./colors";
export { default as logosImages } from "./logosImages";
export { default as coverImages } from "./coverImages";
export { default as loginPageConstants } from "./loginPageConstants";
export { default as registerPageConstants } from "./registerPageConstants";
